<template>
<v-container class="pa-0 pb-12">
	<v-row>
		<v-col>
			<c-input v-model="search" :title="$t('text.search')"></c-input>
		</v-col>
	</v-row>
	<v-row class="px-3 fill-height scroll-wrapper" ref="row">
		<v-col
			cols="12"
			md="12" class="pa-0">
			<v-card color="#000" width="100%" class="mx-auto" rounded="0">
				<v-card-title class="tabel-header">
				{{$t('text.competitions')}}
				</v-card-title>
				<v-card-text class="pa-0">
					<div v-for="(e, i) in filteredEventCompetitions" @click="openNewEventRegistration(e)" class="f-row data-row pl-1" :class="{ 'zebra-dark': (i%2), 'zebra-light': !(i%2)}" :key="i">
						<div class="f-row date">
							<div class="day">{{ e.eventDate | moment('DD') }}</div>
							<div>
								<div>{{ e.eventDate | moment('MMM') }}</div>
								<div>{{ e.eventDate | moment('YYYY') }}</div>
							</div>
						</div>
						<div class="pl-3 data w-50">
							<div>{{ e.name }}</div>
							<div>{{ e.city }} - {{ e.country }}</div>
						</div>
						<div class="pl-3 data w-50">
							<div>{{ $t('text.registrations') }}:
								<template v-if="e.maxPeople !== 0">({{ e.maxPeople }}/{{ e.currentPeople }})</template>
								<template v-if="e.maxPeople === 0">({{ $t('text.unlimited') }}/{{ e.currentPeople }})</template>
							</div>
							<div></div>
						</div>
					</div>
					<div v-if="filteredEventCompetitions.length === 0" class="no-data">{{$t('text.noDataText')}}</div>
				</v-card-text>
			</v-card>
			<spinner :loading="loading"></spinner>
		</v-col>
	</v-row>
</v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import namespace from '../store/namespace';
import eventRegistrationActions from '../store/actions/eventRegistration';
import Spinner from '../general/Spinner.vue';
import CInput from '../globalComponents/CInput.vue';

import modelState from '../mixins/modelState';

export default {
	name: 'EventCompetitions',
	mixins: [modelState],
	components: {
		Spinner,
		CInput,
	},
	data() {
		return {
			loading: true,
			search: '',
			headers: [
				{
					text: '',
					value: 'date',
				},
			],
		};
	},
	async mounted() {
		await this.loadData();
		this.$refs.row.style.height = `${this.WindowSize.y - 170}px`;
	},
	watch: {
		'WindowSize.y': function () {
			this.$refs.row.style.height = `${this.WindowSize.y - 170}px`;
		},
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.EVENTREGISTRATION, ['Links', 'EventCompetitions']),
		filteredEventCompetitions() {
			if (this.search !== '') {
				return this.EventCompetitions.filter(x => x.name.includes(this.search)
				|| x.city.includes(this.search)
				|| x.country.includes(this.search)
				|| this.$moment(x.eventDate).format('DD.MM.YYYY').includes(this.search));
			}
			return this.EventCompetitions;
		},
	},
	methods: {
		...mapActions(namespace.EVENTREGISTRATION, [
			eventRegistrationActions.GET_EVENT_REG_LINKS,
			eventRegistrationActions.GET_EVENT_COMPETITIONS]),
		...mapMutations(namespace.EVENTREGISTRATION, [
			eventRegistrationActions.SET_SELECTED_EVENT,
		]),
		async loadData() {
			this.loading = true;
			try {
				await this.GET_EVENT_REG_LINKS();
				await this.GET_EVENT_COMPETITIONS();
			} finally {
				this.loading = false;
			}
		},
		openNewEventRegistration(event) {
			this.SET_SELECTED_EVENT(event);
			this.$router.push({ name: 'newEventRegistration', params: { eGuid: event.id } });
		},
	},
};
</script>

<style lang="scss" scoped>

@import "../globalComponents/style/_globals";

.tabel-header {
	color: $seltec_color;
	height: 40px;
	padding:5px 10px;
	overflow: auto hidden;
	white-space: nowrap;
}

.data-row {
	color: $font-light-color;
	cursor: pointer;
}

.scroll-wrapper {
	overflow: hidden auto;
}

.zebra-dark {
	background-color: $zebra-dark;
}

.zebra-light {
	background-color: $zebra-light;
}

.no-data {
	color:$font-light-color;
	background-color:$sec_color_dark;
	text-align: center;
}

.date {
	font-weight: bold;
	.day {
		line-height: 44px;
		font-size: 44px;
		padding-right: 5px;
	}
}

.data {
	div {
		width: 100%;
		overflow: hidden;
		text-overflow: '...';
		height: 22px;
	}
}
</style>
